// TOP LEVEL IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
// ANTD
import Button from 'components/common/Button';
import Row from 'components/common/Row';

const styles = {
  sectionContainer: {
    height: 275,
    background: '#41424a',
    textAlign: 'center',
  },
  header: {
    color: '#fff',
    margin: 0,
  },
  subheader: {
    color: '#fff',
    margin: 0,
    lineSpacing: 26,
    fontWeight: 300,
  },
  buttonContainer: {
    marginTop: 20,
  },
};

const Content = () => (
  <div>
    <h1 style={styles.header}>Quality has no substitute.</h1>
    {/* <div style={styles.subheader}>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed aliquet pretium dolor, hendrerit mollis leo feugiat et.
			</div> */}
    <div style={styles.buttonContainer}>
      <Link to="/contact">
        <Button type="primary" className="round-button">
          CONTACT US TODAY
        </Button>
      </Link>
    </div>
  </div>
);

const CallOutSection = () => (
  <Row type="flex" align="middle" justify="center" style={styles.sectionContainer}>
    <Content />
  </Row>
);

export default CallOutSection;



// WEBPACK FOOTER //
// ./src/routes/app-home/CallOutSection/index.js